import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/recommendations.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`Get however many of these cards you can`}</strong>{` (given your 5/24 status) in the order most valuable to you. `}<strong parentName="p">{`Recommended application rate is 1 new Chase card every 2-3 months, depending on current offers and risk tolerance! `}</strong>{`My suggested order:`}</p>
    <ol>
      <li parentName="ol">{`Barclays AA Biz (can skip if only interested in cashback)`}</li>
      <li parentName="ol">{`Any Chase biz cards as you want to try to get`}{`*`}{` - `}<strong parentName="li"><u>{`but you may be denied for them right now`}</u></strong></li>
      <li parentName="ol">{`SW personal card of choice`}{`*`}{`*`}</li>
      <li parentName="ol">{`CSR (if focus is travel) or CSP (if only interested in cashback)`}</li>
      <li parentName="ol">{`World of Hyatt (or Chase Freedom Flex, if focusing on cashback)`}</li>
      <li parentName="ol">{`United Explorer (or Chase Freedom Unlimited, if focusing on cashback)`}</li>
      <li parentName="ol">{`Pick the best one for you: Chase BA Visa / IHG / Freedom Flex / Freedom Unlimited (skip if after cashback)`}</li>
    </ol>
    <p><strong parentName="p">{`If you can't get approved for the SW Biz card currently, it will be very difficult to get the SW companion pass right now.`}</strong>{` You'll need a lot of MS or organic spend on the SW personal card to get the companion pass (which might get you shut down by Chase), and/or advanced strategies. See the What Card Wednesday thread for more details.`}</p>
    <p><strong parentName="p">{`SW RRs cannot be redeemed for Amazon GCs now, but I'm guessing that won't be the case forever.`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      